import React, { Component, PropTypes, cloneElement } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from './redux/AppActions';
import * as searchActions from 'src/redux/searchActions';
import * as cart2Actions from 'src/components/Cart/redux/cartActions';
import {fetchLegalTypes, fetchPartialUserData} from 'src/components/User/redux/userAction';
import { openRegistrationPopup, setRefId } from 'src/components/RegistrationPopup/redux/registrationPopupActions';
import {isAuthenticated, setAuthToken, setUserId} from '../../logic/authHelpers.js';
import {removePartialSettingsFromSessionStorage} from '../../logic/api/userData';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import FooterMobile from '../Footer/FooterMobile';
import RegistrationPopup from '../RegistrationPopup/RegistrationPopup';
import SignInPopup from '../SignInPopup/SignInPopup';
import 'style!css!postcss!react-telephone-input/css/default.css';
import 'style!css!postcss!react-dropdown/style.css';
import 'style!css!postcss!slick-carousel/slick/slick.css';
import 'style!css!postcss!slick-carousel/slick/slick-theme.css';
import 'style!css!postcss!react-rater/lib/react-rater.css';
import styles from './App.scss';

import Media from 'react-responsive';

import { browserHistory } from 'react-router';

try {
  window.opener.passFBAuthCode(window.location.search.split('=')[1], window);
} catch (err) {}

export class App extends Component {
  getChildContext() {
    return {
      location: this.props.location
    };
  }

  componentWillMount() {
    this.props.actions.init();
    if (this.props.location.pathname == '/secondlogin') {
      removePartialSettingsFromSessionStorage();
      setAuthToken(this.props.location.query.tokendata);
      setUserId(this.props.location.query.id);
      window.location.href = '/';
    }
    this.props.fetchLegalTypes();

    if(!isAuthenticated()){
      removePartialSettingsFromSessionStorage();
    }

    browserHistory.listen((location) => {
      const refId = location.query.ref_id;
      if(refId) {
        this.props.openRegistrationPopup();
        this.props.setRefId(refId);
      }
    });

    window.rrhistory = this.props.history;
  }
  componentDidMount() {

  }
  render() {
    //todo:refactor
    this.props.cart2Actions.getCartCount();
    return (
      <div className={styles.app}>
        <div className="flex-wrapper">
        <RegistrationPopup />
        <SignInPopup />
        <Header />
        { cloneElement(this.props.children) }
        </div>
        <Media query="(min-width: 1025px)">
          <Footer />
        </Media>
        <Media query="(max-width: 1024px)">
          <FooterMobile />
        </Media>
      </div>
    );
  }
}

App.routeTitle = 'Главная';

App.childContextTypes = {
  location: React.PropTypes.object
};

App.propTypes = {
  actions: PropTypes.object.isRequired,
  cart2Actions: PropTypes.object.isRequired,
  searchActions: PropTypes.object.isRequired,
  fetchLegalTypes: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    ...state.appReducer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    cart2Actions: bindActionCreators(cart2Actions, dispatch),
    searchActions: bindActionCreators(searchActions, dispatch),
    fetchLegalTypes: bindActionCreators(fetchLegalTypes, dispatch),
    openRegistrationPopup: bindActionCreators(openRegistrationPopup, dispatch),
    setRefId: bindActionCreators(setRefId, dispatch),
    fetchPartialUserData: bindActionCreators(fetchPartialUserData, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



/** WEBPACK FOOTER **
 ** ./src/components/App/App.jsx
 **/